import React, { useEffect, useState } from 'react';
import { Marker, useGoogleMap } from '@react-google-maps/api';
import { site } from '@panel/commons/helpers';
import IconZP from '../../../assets/icons/llave_ZP.svg';
import IconUB from '../../../assets/icons/markerUB.svg';

const CustomMarkers = ({ coordinates }) => {
  const [showMarkers, setShowMarkers] = useState(true);
  const iconMarker = site.id === 'UBPE' ? IconUB : IconZP;

  const map = useGoogleMap();

  const handleZoom = () => {
    // Sólo se visualizan los marcadores cuándo el zoom >= 11
    const currentZoom = map.getZoom();
    setShowMarkers(currentZoom >= 11);
  };

  useEffect(() => {
    map.addListener('idle', handleZoom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Marker position={coordinates} icon={iconMarker} visible={showMarkers} />;
};

export default CustomMarkers;
